import React, { useState, memo } from "react";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ImportExportIcon from '@mui/icons-material/ImportExport';
import moment from "moment-jalaali";
import ExcelJS from "exceljs";
import Api from "../../utils/api";
import { Loading } from "../../components";

const ContactUsExport = ({ object }) => {
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = { ...object, excel_export: 1 };
            const response = await new Api().get("/contact", params);
            const items = Array.isArray(response) ? response : [];

            if (items.length === 0) {
                setLoading(false);
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("ContactUs");

            worksheet.columns = [
                { header: "نام و نام خانوادگی", key: "name", width: 25 },
                { header: "موبایل", key: "mobile", width: 15 },
                { header: "ایمیل", key: "email", width: 25 },
                { header: "متن پیام", key: "content", width: 50 },
                { header: "وضعیت", key: "status", width: 20 },
                { header: "تاریخ", key: "created_at", width: 25 },
            ];

            items.forEach((item) => {
                worksheet.addRow({
                    name: item.name || '-',
                    mobile: item.mobile || '-',
                    email: item.email || '-',
                    content: item.content || '-',
                    status: item.status === 0 ? 'بررسی نشده' : 'بررسی شده',
                    created_at: moment(item.created_at)
                        .locale('fa')
                        .format('jYYYY/jMM/jDD HH:mm:ss'),
                });
            });

            worksheet.getRow(1).eachCell((cell) => {
                cell.font = { bold: true, size: 14 };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFCCEEFF" },
                };
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                };
            });

            worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                if (rowNumber > 1) {
                    row.eachCell((cell) => {
                        cell.font = { size: 12 };
                        cell.alignment = { horizontal: "center", vertical: "middle" };
                    });
                }
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([
                buffer
            ], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `contactUs_${moment().unix()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error exporting Contact Us data:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Tooltip title="خروجی اکسل">
                <IconButton onClick={fetchData} disabled={loading}>
                    <ImportExportIcon />
                </IconButton>
            </Tooltip>
            {loading && <Loading />}
        </>
    );
};

export default memo(ContactUsExport);
